import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { LuTrash2 } from "react-icons/lu";
import { asyncPostData } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../contexts/alert/AlertProvider";

interface IDeleteGroupButton {
  row: any;
  apiCode: string;
}

function DeleteGroupButton({ row, apiCode }: IDeleteGroupButton) {
  const { showAlert } = useAlertContext();
  const token = useSelector((state: any) => state.auth.token);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    if (loading) return;
    setLoading(true);
    const resp = await asyncPostData({
      apiCode,
      token,
      data: { key: "", name: "" },
      condition: { q: { id: row.key } },
      extraUrl: "/updateskeysearch",
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          `Lỗi khi xóa id '${row.key}'`,
      });
      setLoading(false);
      return;
    } else {
      showAlert({
        type: "success",
        message: "Lưu thành công",
      });
      setLoading(false);
      document.getElementById("btn-reload-list")?.click();
    }
  };

  return (
    <Tooltip arrow placement="top" title="Xóa">
      <IconButton
        onClick={() => {
          showAlert({
            type: "info",
            message: `Bạn có chắc muốn xóa không ?`,
            onConfirm: handleDelete,
          });
        }}
      >
        <LuTrash2 size={20} />
      </IconButton>
    </Tooltip>
  );
}

export default DeleteGroupButton;
